import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

const platformCondition = !IS_WEBVIEW && !IS_MOBILE_BROWSER;

/** BOARD-2127 Отображать ли кнопку создания доски в дропдауне "Создать" */
export const enableDropdownCreateBoardButton = platformCondition && !!isFeature('enable-dropdown-create-board-button');

/** BOARD-2127 Отображать ли пункт меню "Доска" в сайдбаре */
export const enableMenuBoardButton = platformCondition && !!isFeature('enable-menu-board-button');

export const boardUrl: string = getFeature('board-entry-points-home-url') || 'https://board.mail.ru';

export const createBoardUrl: string = getFeature('board-entry-points-create-url') || 'https://board.mail.ru?new=personal';
